import { debounce } from '../../../ui/debounce';
import { Events } from '../events/app-events';
import { eventBus } from '../utils/event-bus';
import { BaseService } from './base-service';

export class MobileDeviceService extends BaseService {
  static serviceName = 'mobileDeviceService';

  static mobileDetected = false;
  static mobileHeight = 0;

  private initialScreenHeight: number;
  private isKeyboardOpen = false;

  public bus = eventBus();

  constructor() {
    super();
    this.initialScreenHeight = MobileDeviceService.mobileHeight;
    this.scrollActiveElementToView = debounce(
      this.scrollActiveElementToView,
      400,
    );
    if (
      MobileDeviceService.mobileDetected &&
      MobileDeviceService.mobileHeight
    ) {
      // @ts-ignore
      navigator?.virtualKeyboard?.addEventListener('geometrychanged', (event: any) => {
        const { x, y, width, height } = event.target;
        console.log('Virtual keyboard geometry changed:', x, y, width, height);
      });
      window.addEventListener(
        'resize',
        debounce(() => {
          if (!window.visualViewport){
            return;
          }
          const newHeight = window.visualViewport.height;
          if (newHeight + 200 < this.initialScreenHeight) {
            this.setKeyboardState(true);
            console.log(
              'keyboard guessed size = ' +
              (this.initialScreenHeight - newHeight),
            );
          } else {
            this.setKeyboardState(false);
          }
        }, 250) as EventListener,
      );
      this.initializeSwipeEvents();
    }
  }

  private initializeSwipeEvents() {
    const allowedTime = 300;
    const threshold = 100;
    let startX = 0,
      startY = 0,
      endX = 0,
      endY = 0;
    let startTime = 0,
      endTime = 0;
    document.body.addEventListener('touchstart', (event: TouchEvent) => {
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
      startTime = Date.now();
      return false;
    });

    document.body.addEventListener('touchend', (event: TouchEvent) => {
      endX = event.changedTouches[0].clientX;
      endY = event.changedTouches[0].clientY;
      endTime = Date.now();

      if (endTime - startTime < allowedTime) {
        const distY = Math.abs(endY - startY);
        const distX = Math.abs(endX - startX);
        if (distY > threshold || distX > threshold) {
          const dir =
            distY > distX
              ? endY > startY
                ? 'D'
                : 'U'
              : endX > startX
                ? 'R'
                : 'L';
          eventBus().emit(Events.Type.Swipe, dir);
        }
      }
    });
  }

  scrollActiveElementToView() {
    let el = document.activeElement;
    while (el) {
      const possibleNextActive = el.shadowRoot?.activeElement;
      if (possibleNextActive) {
        el = possibleNextActive;
      } else {
        break;
      }
    }
    if (el) {
      const top = el.getBoundingClientRect().top;
      const bottom = el.getBoundingClientRect().bottom;
      const controls_height = 120;
      if (!window.visualViewport){
        return;
      }
      if ((top < 0 || top > window.visualViewport.height)
      || bottom+controls_height > window.visualViewport.height) {
        el?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  }

  setKeyboardState(state = false) {
    if (state !== this.isKeyboardOpen) {
      this.isKeyboardOpen = state;
      this.bus.emit(Events.Type.KeyboardStateChanged, this.isKeyboardOpen);
      if (state) {
        setTimeout(() => {
          this.scrollActiveElementToView();
        }, 350);
      }
    }
  }

  getKeyboardOpen() {
    return this.isKeyboardOpen;
  }

  getBus() {
    return this.bus;
  }
}

// MobileDeviceService.define();
